module.exports = __webpack_public_path__ + "static/media/yan.ceced821.jpg";